import React, { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { uploadFile } from "../../lib/upload";
import { formatApiError } from "../../lib/api";

export const UploadButton = ({ accept, isPublic, onUploaded, label = "Upload", className = "", testid = "upload-btn" }) => {
  const ref = useRef(null);
  const [pct, setPct] = useState(null);

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setPct(0);
    try {
      const media = await uploadFile(file, { isPublic, onProgress: setPct });
      toast.success(`${file.name} uploaded.`);
      onUploaded?.(media);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setPct(null); }
  };

  return (
    <>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={onChange} data-testid={`${testid}-input`} />
      <button type="button" disabled={pct !== null} onClick={(e) => { e.preventDefault(); e.stopPropagation(); ref.current?.click(); }}
        className={`inline-flex items-center gap-2 rounded-full bg-white text-brand-ink border border-brand-line px-3 py-1.5 text-xs font-semibold shadow-sm hover:bg-brand-cream2 transition-colors disabled:opacity-70 ${className}`}
        data-testid={testid}>
        <Upload size={14} /> {pct !== null ? `Uploading ${pct}%` : label}
      </button>
    </>
  );
};
